var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.layout,{tag:"component",attrs:{"id":"app"}},[_c('router-view')],1),_c('RiLoading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }